import React from 'react';
import './footer.css'
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { Link, useLocation } from 'react-router-dom';
import { FaLinkedinIn } from "react-icons/fa";


const Footer = () => {

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const location = useLocation();
    console.log("path", location.pathname);

    const isContactPage = location.pathname === '/contact' || location.pathname === '/service'

    const footerStyle = {
        paddingTop: isContactPage ? '75px' : '0px',
        marginTop: isContactPage ? '0px' : '125px'
    }

    return (
        <footer style={footerStyle}>
            <div className="container">
                <div className="row">
                    {
                        !isContactPage && (
                            <div className='RedBox' data-aos="fade-up">
                                <div className="Left">
                                    <h2>Ready to get started? Let’s <br /> talk to us today</h2>
                                    <p>Have questions, need assistance, or want to explore opportunities with us? Let’s connect!</p>
                                    <Link to="/contact" className='GetAQuote' onClick={scrollToTop} >Contact Us</Link>
                                </div>
                                {/* <div className="Right">
                                    <img src={require('../../assets/images/white-arrow.jpg')} />
                                </div> */}
                            </div>
                        )
                    }

                    <div className="col-lg-3 col-md-12">
                        <div className="FooterLinks">
                            <Link to="/"><img src={require('../../assets/images/logo.png')} onClick={scrollToTop} alt='img' /></Link>
                            <p>
                                Wallet-Friendly. Eco-Friendly. Future-Ready</p>
                            <p className='mb-1'>Follow Us</p>
                            <h3>Stay updated with our latest innovations and initiatives!</h3>
                            <ul>
                                <li><a href="https://www.twitter.com/IlineIndia" target='_blank'><FaXTwitter /></a></li>
                                <li><a href="https://www.facebook.com/IlineIndia" target='_blank'><FaFacebookSquare /></a></li>
                                <li><a href="https://www.instagram.com/iline.ai/" target='_blank'><FaInstagram /></a></li>
                                <li><a href="https://www.linkedin.com/company/ilineindia" target='_blank'><FaLinkedinIn /></a></li>

                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-12">
                        <div className="FooterLinks">
                            <p>D-9, Vyapar Marg, Block D, <br />
                                Sector 3 Noida, Uttar Pradesh, <br /> Noida,
                                Delhi 201301</p>
                            <p>+ 91 9220536259</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="FooterLinks">
                            <h1>Stay Tuned</h1>
                            <h3>Subscribe to our newsletter <br /> and never miss our news.</h3>
                            <form>
                                <div className="form-group">
                                    <input type="text" className='form-control' placeholder='Email' />
                                </div>
                                <button>Subscribe</button>
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="BottomNav">
                            <ul>
                                <li><Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link></li>
                                <li><Link to="/terms-conditions" onClick={scrollToTop}>Terms & Conditions</Link></li>
                                <li><Link to="/cancellation-and-refund" onClick={scrollToTop}>Cancellation and Refund</Link></li>
                                <li><Link to="/shipping-and-delivery" onClick={scrollToTop}>Shipping and Delivery</Link></li>
                                {/* <li><Link href="">Home </Link></li>
                                <li><Link href="">Home 2</Link></li>
                                <li><Link href="">Home 3</Link></li> */}
                                {/* <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/service">services</Link></li> */}
                            </ul>
                            <p>
                                &copy;I-LINE.AI SOLUTIONS PRIVATE LIMITED. All Rights Reserved 2024.
                            </p>
                        </div>

                    </div>

                </div>
            </div>
        </footer>
    )
}

export default Footer;